import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const IllustrationCard = ({
  width = 129,
  height = 110,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 129 110"
    fill="none"
    className={className}
  >
    <G clipPath="url(#illustration-card-a)">
      <Rect
        x="43.3525"
        y="26"
        width="85.6465"
        height="57.0984"
        rx="4.75695"
        fill="#FE7165"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129 30.9774C123.761 31.2629 118.582 33.2468 114.369 36.9833C104.53 45.7077 103.7 60.6779 112.513 70.4161C116.917 75.284 122.894 77.924 129 78.2598L129 30.9774Z"
        fill="#FDBD9A"
      />
    </G>
    <G clipPath="url(#illustration-card-b)">
      <Rect
        x="34.2021"
        y="60.8936"
        width="22.4083"
        height="6.04215"
        rx="3.02108"
        fill="white"
      />
      <Rect
        x="20.0495"
        y="60.8936"
        width="10.6144"
        height="6.04215"
        rx="3.02108"
        fill="white"
      />
      <Rect
        x="21.2289"
        y="80.2285"
        width="35.3815"
        height="6.04215"
        rx="3.02108"
        fill="white"
      />
      <Rect
        x="11.7938"
        y="80.2285"
        width="5.89691"
        height="6.04215"
        rx="2.94846"
        fill="white"
      />
      <Rect
        x="9.43506"
        y="70.561"
        width="12.9732"
        height="6.04215"
        rx="3.02108"
        fill="white"
      />
      <Rect
        y="70.561"
        width="5.89691"
        height="6.04215"
        rx="2.94846"
        fill="white"
      />
      <Rect
        x="25.9464"
        y="70.561"
        width="35.3815"
        height="6.04215"
        rx="3.02108"
        fill="white"
      />
    </G>
    <Defs>
      <ClipPath id="illustration-card-a">
        <Rect
          width="85.6475"
          height="57.0984"
          fill="white"
          transform="translate(43.3525 26)"
        />
      </ClipPath>
      <ClipPath id="illustration-card-b">
        <Rect
          width="61.3279"
          height="25.377"
          fill="white"
          transform="translate(0 60.8936)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
